// AI Generated Test
import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { PAGE_FIX_EVENT } from '../../constants/page-fix-event';

@Component({
    selector: 'page-fix-form-info-view',
    templateUrl: './info-view.component.html',
    standalone: false,
})
export class PageFixFormInfoViewComponent implements OnInit, OnDestroy {
    @Input() monName?: any;
    @Input() monType: any;
    @Input() monSelected?: any;
    @Input() monOrder: any;
    @Input() monTitle?: any;
    @Input() monFooter?: any;

    constructor (
        private elementRef: ElementRef,
        private monEventService: MonEventService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    ngOnDestroy (): void {
        this.onDestroy();
    }

    private activate (): void {
        this.monEventService.run(PAGE_FIX_EVENT.REGISTER_VIEW, this.elementRef.nativeElement, {
            type: this.monType,
            order: this.monOrder,
            footer: this.monFooter,
            title: this.monTitle,
            viewName: this.monName,
            selected: this.monSelected,
        });
    }

    private onDestroy (): void {
        this.monEventService.run(PAGE_FIX_EVENT.UNREGISTER_VIEW, this.elementRef.nativeElement);
    }
}
